import { useDispatch } from "react-redux";
import {
  setKeywordReleventScoreLoading,
  setLpLoader,
  setPageSpeedMetricsLoading,
  setUrlKeywordsLoading,
} from "../../../features/landingPageExperienceSlice";
import { LPExperienceEndPointLogic } from "../../../logic/PaidTrafficManagement/LandingPageExperience/landingPageExperienceEndPointLogic";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { selectUserToken } from "../../../features/userSlice";

export function useFetchKeywordDetails() {
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  // const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const queryId = "5769252946575360";
  const queryId2 = "5631003024424960";
  const queryId3 = "5696446112202752";
  const queryId4 = "5696855140728832";
  const queryId5 = "5689540979195904";
  const queryId6 = "5737003958140928";

  const fetchKeywordDetails = async () => {
    dispatch(setLpLoader(true));
    try {
      const payload = {
        oauthTokenHeader,
        startDate: searchParams.get("start_date"),
        endDate: searchParams.get("end_date"),
        queryId,
        websiteSharedUid: searchParams.get("selectedSite"),
        platformAccountId: searchParams.get("account"),
        kwInternalId: searchParams.get("keyword_internal_id"),
        page_shared_uid: 1,
        type: "site",
      };

      const res =
        await LPExperienceEndPointLogic.getSingleKeywordDetailsByInternalId(
          payload
        );

      if (
        res &&
        res?.data?.data?.query_output &&
        res?.data?.data?.query_output.length > 0
      ) {
        const maxClicksResult = res.data.data.query_output.reduce(
          (max: any, current: any) =>
            current.clicks > max.clicks ? current : max
        );

        const websitePageId = maxClicksResult?.page_id;
        const websitePageSharedUid = maxClicksResult?.page_shared_uid;

        searchParams.set("website_page_id", websitePageId);
        searchParams.set("website_page_shared_uid", websitePageSharedUid);
        setSearchParams(searchParams);

        // Wait for all 3 API calls to finish
        await Promise.all([
          getKeywordReleventScore(),
          fetchPageSpeedMetrics(),
          fetchEngagementMetrics(),
        ]);
      }

      return res;
    } catch (error) {
      console.error("Error fetching keyword details:", error);
      throw error;
    } finally {
      //This will only run AFTER Promise.all finishes (or errors)
      dispatch(setLpLoader(false));
    }
  };

  const getKeywordReleventScore = async () => {
    try {
      dispatch(setKeywordReleventScoreLoading(true));
      const payload5 = {
        oauthTokenHeader,
        websiteSharedUid: searchParams.get("selectedSite"),
        kwInternalId: searchParams.get("keyword_internal_id"),
        website_page_id: searchParams.get("website_page_id"),
      };

      const res = await LPExperienceEndPointLogic.getKeywordReleventScore(
        payload5
      );
      return res;
    } catch (error) {
      console.error("Error fetching keyword relevent score:", error);
      throw error;
    } finally {
      dispatch(setKeywordReleventScoreLoading(false));
    }
  };

  const postKeywordReleventScore = async () => {
    try {
      dispatch(setKeywordReleventScoreLoading(true));
      const payload5 = {
        oauthTokenHeader,
      };
      const data = {
        keyword_id: searchParams.get("keyword_internal_id"),
        website_page_id: searchParams.get("website_page_id"),
      };

      const res = await LPExperienceEndPointLogic.postKeywordReleventScore(
        payload5,
        data
      );
      return res;
    } catch (error) {
      console.error("Error fetching keyword relevent score:", error);
      throw error;
    } finally {
      dispatch(setKeywordReleventScoreLoading(false));
    }
  };

  // 🔹 This is separated and not auto-called. Use on button click.
  const fetchKeywordsLinkedToURL = async (pageSharedUid: string | number) => {
    try {
      dispatch(setUrlKeywordsLoading(true));
      const payload = {
        oauthTokenHeader,
        startDate: searchParams.get("start_date"),
        endDate: searchParams.get("end_date"),
        queryId,
        websiteSharedUid: searchParams.get("selectedSite"),
        kwInternalId: 1, // adjust as needed
        page_shared_uid: pageSharedUid, // passed dynamically
      };

      const res = await LPExperienceEndPointLogic.getKeywordsLinkedToURL(
        payload
      );
      return res;
    } catch (error) {
      console.error("Error fetching keywords linked to URL:", error);
      throw error;
    } finally {
      dispatch(setUrlKeywordsLoading(false));
    }
  };

  const fetchSingleKeywordDetails = async () => {
    const payload2 = {
      oauthTokenHeader,
      startDate: searchParams.get("start_date"),
      endDate: searchParams.get("end_date"),
      queryId: queryId2,
      websiteSharedUid: searchParams.get("selectedSite"),
      platformAccountId: searchParams.get("account"),
      campaign_id: 1,
      kwInternalId: searchParams.get("keyword_internal_id"),
    };
    try {
      dispatch(setLpLoader(true));
      const res = await LPExperienceEndPointLogic.getSingleKeywordDetails(
        payload2
      );
      return res;
    } catch (error) {
      console.error("Error fetching keyword details:", error);
      throw error;
    }
  };

  const fetchDailyLPExperienceDetails = async () => {
    const payload3 = {
      oauthTokenHeader,
      queryId: queryId3,
      startDate: searchParams.get("start_date"),
      endDate: searchParams.get("end_date"),
      websiteSharedUid: searchParams.get("selectedSite"),
      platformAccountId: searchParams.get("account"),
      kwInternalId: searchParams.get("keyword_internal_id"),
      campaign_id: 1,
      dimension: searchParams.get("dimension_name"),
      type: "site",
    };
    try {
      dispatch(setLpLoader(true));
      const res = await LPExperienceEndPointLogic.getDailyLPExperienceDetails(
        payload3
      );
      return res;
    } catch (error) {
      console.error("Error fetching keyword details:", error);
      throw error;
    }
  };

  const fetchCompetitorMetricsAccordion = async () => {
    const payload4 = {
      oauthTokenHeader,
      queryId: queryId4,
      startDate: searchParams.get("start_date"),
      endDate: searchParams.get("end_date"),
      websiteSharedUid: searchParams.get("selectedSite"),
      kwInternalId: searchParams.get("keyword_internal_id"),
    };
    try {
      dispatch(setLpLoader(true));
      const res = await LPExperienceEndPointLogic.getCompetitorMetricsAccordion(
        payload4
      );
      return res;
    } catch (error) {
      console.error("Error fetching competitor metrics:", error);
      throw error;
    }
  };

  const fetchPageSpeedMetrics = async () => {
    const payload5 = {
      oauthTokenHeader,
      queryId: queryId5,
      startDate: searchParams.get("start_date"),
      endDate: searchParams.get("end_date"),
      websiteSharedUid: searchParams.get("selectedSite"),
      website_page_shared_uid: searchParams.get("website_page_shared_uid"),
    };
    try {
      dispatch(setPageSpeedMetricsLoading(true));
      const res = await LPExperienceEndPointLogic.getPageSpeedMetrics(payload5);
      return res;
    } catch (error) {
      console.error("Error fetching page speed metrics:", error);
      throw error;
    } finally {
      dispatch(setPageSpeedMetricsLoading(false));
    }
  };

  const fetchEngagementMetrics = async () => {
    const payload6 = {
      oauthTokenHeader,
      queryId: queryId6,
      startDate: searchParams.get("start_date"),
      endDate: searchParams.get("end_date"),
      websiteSharedUid: searchParams.get("selectedSite"),
      website_page_shared_uid: searchParams.get("website_page_shared_uid"),
    };
    try {
      dispatch(setPageSpeedMetricsLoading(true));
      const res = await LPExperienceEndPointLogic.getEngagementMetrics(
        payload6
      );
      return res;
    } catch (error) {
      console.error("Error fetching engagement metrics:", error);
      throw error;
    } finally {
      dispatch(setPageSpeedMetricsLoading(false));
    }
  };

  return {
    fetchKeywordDetails,
    fetchKeywordsLinkedToURL, // now exposed for button click
    fetchSingleKeywordDetails,
    fetchDailyLPExperienceDetails,
    fetchCompetitorMetricsAccordion,
    getKeywordReleventScore,
    postKeywordReleventScore,
    fetchPageSpeedMetrics,
    fetchEngagementMetrics,
  };
}
